import { ACTION_TYPES } from '@/actions';
import {
  setYSFOpenid,
  setWXOpenid, setWXUnionid,
  setLogin, setToken,
  clearLogin
} from '@/core/authUtil';

const INIT_STATE = {
  ysfAuth: {}
};

/**
 * 处理云闪付注册成功事件
 */
function handleYSFLogin({ openId, isMember, token }) {
  setYSFOpenid(openId);
  if (isMember === 1) {
    console.log('已是会员', isMember);
    setLogin();
    setToken(token);
  } else {
    console.log('不是会员');
    clearLogin();
  }
}

/**
 * 处理H5商城注册成功事件
 */
function handleShopLogin({ token }) {
  setLogin();
  setToken(token);
}

/**
 * 处理根据微信授权信息判断用户注册状态
 */
function handleWXCode({ unionId, userType, token }) {
  setWXUnionid(unionId);
  if (userType === 2) {
    setLogin();
    setToken(token);
  }
}

export default function auth(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 云闪付注册成功
    case ACTION_TYPES.REGISTER_YSF_BY_MOBILE:
      handleYSFLogin(payload);
      result.ysfAuth = payload;
      break;
    // 根据微信授权信息判断用户注册状态
    case ACTION_TYPES.GET_WX_REGISTER_INFO_BY_CODE:
      handleWXCode(payload);
      break;
    // H5商城注册成功
    case ACTION_TYPES.REGISTER_SHOP_BY_MOBILE:
      handleShopLogin(payload);
      break;
    // 根据微信授权信息注册
    case ACTION_TYPES.REGISTER_SHOP_BY_WX:
      handleShopLogin(payload);
      break;
    // 退出登录
    case ACTION_TYPES.LOG_OUT:
      clearLogin();
      result = INIT_STATE;
      break;
    default:
      result = state;
  }
  return result;
}
